import React from 'react'

const NoFoundPage = () => {
  return (
    <div className='position-absolute top-50 end-50'>
      <h2>Page not found</h2>
    </div>
  )
}

export default NoFoundPage